import { createContext } from 'react';

export type ShippoTokenContextData = string;

export const ShippoTokenContext = createContext<ShippoTokenContextData | undefined>(undefined);
